$(document).on('ready turbolinks:load', () => {
  $('form[data-disable-submit-on-enter]').off('keypress').on('keypress', (e) => {
    if (e.keyCode === 13) {
      return false;
    }
    return true;
  });
});
